export enum MimeTypes {
  PDF = 'application/pdf',
  TEXT = 'text/plain',
  XLS = 'application/vnd.ms-excel',
  XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  PPT = 'application/vnd.ms-powerpoint',
  PPTX = 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  DOC = 'application/msword',
  DOCX = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  JPG = 'image/jpg',
  JPEG = 'image/jpeg',
  PNG = 'image/png',
  SVG = 'image/svg+xml',
  HEIC = 'image/heic',
  HEIF = 'image/heif',
  CSV = 'text/csv',
  MP4 = 'video/mp4',
  MOV = 'video/mov',
  WMV = 'video/wmv',
  AVI = 'video/avi',
  HTM = 'text/htm',
  HTML = 'text/html',
  JSON = 'application/json',
  MD = 'text/markdown',
}

export enum FileExtensions {
  MD = '.md',
}
